const windowT:any = window;

export const firebaseConfig = {
  apiKey: windowT.kardsConfiguration.apiKey,
  authDomain: windowT.kardsConfiguration.authDomain,
  databaseURL: windowT.kardsConfiguration.databaseUrl,
  projectId: windowT.kardsConfiguration.projectId,
  storageBucket: windowT.kardsConfiguration.storageBucket,
  messagingSenderId: windowT.kardsConfiguration.messagingSendersId,
  appId: windowT.kardsConfiguration.appId,
  measurementId: windowT.kardsConfiguration.measurementId,
};
